import Immutable from 'immutable';
import { createSelectorCreator, defaultMemoize } from 'reselect';

export default createSelectorCreator(defaultMemoize, Immutable.is);


// WEBPACK FOOTER //
// ./src/selectors/immutableCreatorSelector.js